import "./styles/main.css";
import { registerPlugins } from "@/plugins";
import App from "./App.vue";
import { createApp } from "vue";
import "./utils/dayjs";

const app = createApp(App);

// Nothing awaited before mount: the index.html boot guard only acts while #app is empty and must not see a late failure (ad-blocked vue-matomo).
registerPlugins(app).then(() => app.mount("#app"));
